<script setup>
/**
 * WavoipInitializer — renders nothing visible.
 * Placed in the root App.vue to initialize the WaVoIP webphone
 * when the account has WaVoIP enabled.
 *
 * The WaVoIP SDK renders its own built-in incoming call notification
 * and dialer widget — no custom notification needed.
 */
import { onMounted, onUnmounted, watch } from 'vue';
import { useWavoip } from 'dashboard/composables/useWavoip';

const { isWavoipEnabled, initWebphone, destroyWebphone } = useWavoip();

// Initialize webphone when the feature is enabled
watch(
  () => isWavoipEnabled.value,
  async newVal => {
    if (newVal) {
      await initWebphone();
    } else {
      await destroyWebphone();
    }
  },
  { immediate: false }
);

onMounted(async () => {
  if (isWavoipEnabled.value) {
    await initWebphone();
  }
});

onUnmounted(async () => {
  await destroyWebphone();
});
</script>

<template>
  <!-- SDK renders its own widget UI, nothing needed here -->
  <div />
</template>
